import SiteMenu from './SiteMenu';

export default SiteMenu;
